import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

// localizedFormat enables the LL / ll format tokens that were previously
// provided by moment (used for human-readable dates in SecurityTab).
dayjs.extend(localizedFormat);

export default dayjs;
